module.exports = __webpack_public_path__ + "img/prev.32583ad2.png";